// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3lMYz","footer":"ModalFilter_footer__1uv86"};